import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'joinStringArray',
})
export class JoinStringArrayPipe implements PipeTransform {
  public transform(array: string[], separator = ', '): string {
    return array.join(separator);
  }
}
